module.exports = __webpack_public_path__ + "img/l-hd.3a16b3c9.webp";